// extracted by mini-css-extract-plugin
export default {"main":"Homepage_main__oEh-5","btnCTA":"Homepage_btnCTA__syCCy"};